import React, { Component } from 'react'
import styled from 'styled-components'

import IconEventWhite from '../../assets/icons/event-white.svg'
import IconPlace from '../../assets/icons/place.svg'

const EventCardContentStyle = styled.div`
  position: absolute;
  padding: 20px;
  color: white;
  display: grid;
  align-content: space-between;
  height: calc(100% - 40px);
  width: calc(100% - 40px);
  z-index: 999999999;

  h5 {
    margin-top: 4px;
    color: white;
  }

  .EventCardContentExtra {
    display: grid;
    grid-template-columns: 1fr 1fr;

    div {
      display: flex;
      align-items: center;

      h5 {
        margin-top: 0;
        margin-left: 5px;
        color: white;
      }
  
      img {
        height: 26px;
      }
    }

    div:last-of-type {
      justify-self: right;
    }
  }
`;

export default class EventCardContent extends Component {  
  render() {
    const { eventInfo } = this.props;
  
    return (
      <EventCardContentStyle>
        <div>
          <h2>{eventInfo.frontmatter.name}</h2>
          <h5>{eventInfo.frontmatter.type}</h5>
        </div>
        <div className="EventCardContentExtra">
          <div>
            <img src={IconPlace} alt=""/>
            <h5>{eventInfo.frontmatter.locality}</h5>
          </div>
          <div>
            <img src={IconEventWhite} alt=""/>
            <h5>{eventInfo.frontmatter.date}</h5>
          </div>
        </div>
      </EventCardContentStyle>
    )
  }
}
